import React from 'react';

class Section extends React.Component{

    render(){
      return(
        <section className="section">
          <div className="row">
            <div className="col-md-4">
              <h2 className="section-title">{ this.props.section_title }</h2>
              <p className="section-description">{ this.props.section_description }</p>
            </div>
            <div className="col-md-8">
                { this.props.children }
            </div>
          </div>
        </section>
      );
    }
} 

export { Section };


// WEBPACK FOOTER //
// ./src/components/Section.js